function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1 1)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h48v48H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.816 11.93c1.227-.455 3.574-.706 7.04-.756 3.493-.05 6.152.262 7.978.933a1.72 1.72 0 011.105 1.345l1.14 7.208a1.72 1.72 0 01-1.698 1.988H16.705a1.72 1.72 0 01-1.45-2.643l4.707-7.387a1.72 1.72 0 01.854-.689z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.575 35.58l13.132.016c.16-3.467 3.044-6.227 6.575-6.227 3.536 0 6.423 2.769 6.575 6.242l3.292.004.283-3.069c-.578-.604-.84-1.146-.721-1.67.531-2.336.727-4.68.54-5.668-.986-5.234-2.43-8.822-4.293-10.753-1.981-1.998-4.065-3.4-6.251-4.211-3.322-1.233-12.64-1.271-15.61-.036-.337.14-.593.253-.819.359-.608.287-1.025.554-1.435.927-.578.525-1.174 1.286-2.237 2.838-.358.523-3.252 4.85-4.502 6.685-.528.777-.567.793-5.802 2.8-3.482 1.333-5.189 2.29-5.344 3.154-.174.961-.144 2.416.067 5.71a.973.973 0 01-.01.22c-.024.14-.072.268-.146.411-.037.072-.2.356-.178.314-.145.258-.2.427-.19.637.012.247.05.681.115 1.297l3.812.004c.176-3.452 3.053-6.196 6.573-6.196 3.526 0 6.406 2.752 6.574 6.211zM.696 33.618a5.872 5.872 0 010 0zm20.4-21.648c1.235-.44 3.466-.674 6.729-.72 3.362-.048 5.93.255 7.717.92a2.22 2.22 0 011.384 1.563c.298 1.244.5 2.201.607 2.874.1.628.264 1.948.494 3.968a2.22 2.22 0 01-2.205 2.47H17.53a2.22 2.22 0 01-1.872-3.411l4.31-6.766a2.22 2.22 0 011.129-.898z",
  stroke: "#371447",
  fill: "#64B5F6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.088 32.652a4.689 4.689 0 00-.79 2.61c0 2.616 2.14 4.738 4.779 4.738s4.778-2.122 4.778-4.739a4.692 4.692 0 00-.95-2.837m18.463.228a4.689 4.689 0 00-.789 2.61c0 2.616 2.14 4.738 4.778 4.738 2.64 0 4.779-2.122 4.779-4.739a4.692 4.692 0 00-.95-2.837",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("ellipse", {
  stroke: "#371447",
  cx: 11.077,
  cy: 35.261,
  rx: 2.389,
  ry: 2.369
}), /*#__PURE__*/React.createElement("ellipse", {
  stroke: "#371447",
  cx: 37.357,
  cy: 35.261,
  rx: 2.389,
  ry: 2.369
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "#371447",
  fill: "#64B5F6",
  x: 13.749,
  y: 20.716,
  width: 4.43,
  height: 2.662,
  rx: 1.331
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.537 28.4c.486.064.738.175.754.332.024.239.043.925.058 2.058-.91.49-1.475.692-1.697.604m46.622-3.355c-.78.058-1.28.054-1.502-.012-.097-.029-.137-.796-.157-1.112-.018-.273.028-.485.137-.638.181-.164.304-.246.369-.246.194.003.339.007.434.012",
  stroke: "#371447"
}));

function SvgVehiclesMd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgVehiclesMd;